/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";

export default function Faq() {
  const [FaqList, setFaqList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [Answer, setAnswer] = useState("");
  const [question_type_id, setquestion_type_id] = useState("");
  const [submitLoader, setsubmitLoader] = useState(false);
  const [Question, setQuestion] = useState("");
  const [QuestionType, setQuestionType] = useState("");

  useEffect(() => {
    getQuestionList();
  }, [search_key, currentPage]);

  useEffect(() => {
    getQuestionTypeList();
  }, []);
  const getQuestionList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_QUESTIONS_LIST, param).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setFaqList(res?.data?.data?.rows);
        SetTotalPageCount(res.data.totalPages);
        SetTotalCount(res.data.totalItems);
        setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  function Delete(id, name) {
    const data = {
      id: id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_QUESTIONS, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getQuestionList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  const getQuestionTypeList = () => {
    setLoading(true);
    PostService(API_URL.GET_QUESTIONS_TYPE_LIST).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setQuestionType(res?.data?.data?.rows);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  const [selectedData, setSelectedData] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    setQuestion(selectedData?.topquestion);
    setAnswer(selectedData?.answer);
    setquestion_type_id(
      selectedData?.question_type_id ? selectedData?.question_type_id : ""
    );
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();
    console.log("sdj");

    if (!Question || !Answer) {
      setError(true);
      return;
    }

    setsubmitLoader(true);
    const data = {
      question_type_id: Number(question_type_id),
      topquestion: Question,
      answer: Answer,
    };
    if (selectedData?.topquestionid) {
      data.id = selectedData?.topquestionid;
    }
    const route = selectedData?.topquestionid
      ? API_URL.UPDATE_QUESTIONS
      : API_URL.CREATE_QUESTION_LIST;

    PostService(route, data).then(
      (res) => {
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getQuestionList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
          setsubmitLoader(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setsubmitLoader(false);
      }
    );
  };

  function resetFunc() {
    setQuestion("");
    setAnswer("");
    setError(false);
    setquestion_type_id("");
    setsubmitLoader(false);
    setSelectedData("");
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>FAQ List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">FAQ List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="align-items-center d-flex justify-content-end row">
                    <div className="col-md-8 p-0">
                      <div className="ml-4">
                        <button
                          className="btn btn-primary py-2"
                          data-toggle="modal"
                          data-target="#EditModal"
                          onClick={resetFunc}
                        >
                          Add Faq
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Question"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive mt-3">
                    {!loading && (
                      <table className="table table-hover text-nowrap table-striped table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Question</th>
                            <th className="text-center">Answer</th>
                            <th className="text-center">Question Type</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {FaqList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td>{i + S_No_Count + 1}</td>
                              <td>{data?.topquestion}</td>
                              <td
                                style={{
                                  whiteSpace: "break-spaces",
                                  lineHeight: "1.2",
                                }}
                              >
                                {data?.answer}
                              </td>
                              <td>{data?.question_type?.name}</td>
                              <td className="text-center">
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                                <span
                                  title="Delete"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  onClick={() => {
                                    Delete(data?.topquestionid, "Question");
                                  }}
                                >
                                  <i className="text-danger fas fa-trash"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {FaqList && FaqList.length === 0 && (
                            <tr>
                              <td colSpan="9" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                FAQ
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <label>Question Type</label>
                    <select
                      className="form-control"
                      onChange={(e) => setquestion_type_id(e?.target?.value)}
                      value={question_type_id}
                    >
                      <option value="">Select Type</option>
                      {QuestionType &&
                        QuestionType?.map((res, i) => (
                          <option value={res?.id} key={i}>
                            {res?.name}
                          </option>
                        ))}
                    </select>
                    {error && !question_type_id && (
                      <div className="error">Question type cannot be empty</div>
                    )}
                  </div>
                  <div className="col-12 mt-3">
                    <label>Question</label>
                    <input
                      type="text"
                      name="name"
                      value={Question}
                      className="form-control"
                      onChange={(e) => setQuestion(e.target.value)}
                      placeholder="Enter Question"
                    />
                    {error && !Question && (
                      <div className="error">Question cannot be empty</div>
                    )}
                  </div>

                  <div className="col-12 mt-3">
                    <label>Answer</label>
                    <textarea
                      type="text"
                      name="name"
                      value={Answer}
                      className="form-control"
                      onChange={(e) => setAnswer(e.target.value)}
                      placeholder="Enter Answer"
                    ></textarea>

                    {error && !Answer && (
                      <div className="error">Answer cannot be empty</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : selectedData?.topquestionid ? (
                    "Update"
                  ) : (
                    "Add"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
